module.exports = __webpack_public_path__ + "img/Step2m.d61cd742.png";